import * as actionTypes from '../actions/actionTypes';

const initialState = {
  logoUrl: './assets/images/c24_logo_small.svg',
  isParamsPassed: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.PARTNER_IFRAME_MESSAGE_RECEIVED: {
      const params = action.data.params;
      return {
        ...state,
        ...params,
        isParamsPassed: true,
      };
    }
    case actionTypes.PARTNER_IFRAME_CLOSE_USP:
      return {
        ...state,
        uspPageUrl: null,
      };
    default:
      return state;
  }
}
